import { appInjector } from '../app-injector';
import { WaitingIndicatorService } from '../core-services/WaitingIndicator.service';

/*
    Note that passing lambdas in does not work well because of how decorators are
    implemented. For this reason use the construct "function() {...}" in order
    to preserve the right object context.
*/
export class WaitingIndicatorDecorator {
    /*
    I created this second method because I think my whle waiting structure was
    a little over-engineered and I wanted something simple and quickly useful
    instead of something that people didn't want to use.
    */

    public static runOnWait(
        setWaiting: (bool: boolean) => void,
        waitTime = 300
    ) {
        return function (_target: any, _name: string, property: any) {
            const fn = property.value;
            property.value = function (...args: any[]) {
                let startIndicatorTimeout: number;
                let returnedValue = fn.apply(this, args);
                if (returnedValue instanceof Promise) {
                    startIndicatorTimeout = window.setTimeout(() => {
                        setWaiting.apply(this, [true]);
                    }, waitTime);
                    returnedValue = returnedValue.finally(() => {
                        clearTimeout(startIndicatorTimeout);
                        setWaiting.apply(this, [false]);
                    });
                } else {
                    throw new Error(
                        'Attempting to apply ActivateWaitingTag to synchronous' +
                            ' code! Check to make sure you are returning a Promise.'
                    );
                }
                return returnedValue;
            };
        };
    }

    public static blockScreenOnWait(waitTime = 300) {
        return WaitingIndicatorDecorator.runOnWait((wait: boolean) => {
            const waitingService = appInjector().get(WaitingIndicatorService);
            waitingService.blockScreen = wait;
        }, waitTime);
    }

    public static activateWaitingTag(
        tagNameSource: () => string,
        waitTime = 300
    ) {
        return WaitingIndicatorDecorator.runOnWait(function (
            this: any,
            wait: boolean
        ) {
            const tagName =
                typeof tagNameSource === 'function'
                    ? tagNameSource.apply(this)
                    : tagNameSource;
            const waitingService = appInjector().get(WaitingIndicatorService);
            waitingService.setWaitingTag(tagName, wait);
        }, waitTime);
    }
}
